import "./apimsglog.scss";
import { useEffect, useState } from "react";
import DatePicker from "react-date-picker";
import { Button, Dropdown, Form, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import threedotvertical from "../../assets/images/three-dots-vertical.svg";
import viewicon from "../../assets/images/view-icon.svg";
import CustomModal from "../../components/customModal/CustomModal";
import { ReactSVG } from "react-svg";
import useRecordUsage from "../../Hooks/useRecordUsage";
import * as Yup from "yup";
import { FormikHelpers, useFormik } from "formik";
import {
  ApiLog,
  MessageLog,
  TypeLog,
} from "../../redux/recordUsage/recordUsageApiSlice";
import { DropDownValues } from "../../utils/types";
import Select from "react-select";
import moment from "moment";
import Loading from "../../components/LoadingPage/Loading";
import { parseBoolean } from "../../utils/commonUtils";
import duplicateicon from "../../assets/images/duplicate-icon.svg";

const ApiMsgLog = () => {
  const [typeOptions, setTypeOptions] = useState([]);
  const [errorCodeOptions, setErrorCodeOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState<ApiLog>();
  const [logList, setLogList] = useState<ApiLog[]>([]);
  const [tooltipText, setTooltipText] = useState("Copy to clipboard");
  const initialForm = {
    message: "",
    barcode: "",
    type: "",
    fromDate: moment()
      .subtract(7, "days")
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
    toDate: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
    rowCount: 10,
  };
  const [dynamicForm, setDynamicForm] = useState(initialForm);
  const { logDDCalAPI, logDDCalLoading, getLogListAPI, getLogListLoading } =
    useRecordUsage();

  const toggleModal = () => {
    setShowModal(!showModal);
  };
  const renderTooltip = (props: any) => (
    <Tooltip id="copy-tooltip" {...props}>
      {tooltipText}
    </Tooltip>
  );
  const handleCopy = (text: string) => {
    if (!text) return;
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setTooltipText("Copied!");
        setTimeout(() => setTooltipText("Copy to clipboard"), 2000);
      })
      .catch(() => {
        setTooltipText("Failed to copy");
        setTimeout(() => setTooltipText("Copy to clipboard"), 2000);
      });
  };
  const getList = (values: any) => {
    getLogListAPI(values).then((res) => setLogList(res));
  };
  useEffect(() => {
    logDDCalAPI().then((res) => {
      if (res?.messages) {
        setErrorCodeOptions(
          res?.messages.map((item: MessageLog) => {
            return {
              label: item.value,
              value: item.key,
            };
          })
        );
      }
      if (res?.types) {
        setTypeOptions(
          res?.types.map((item: TypeLog) => {
            return {
              label: item.value,
              value: item.key,
            };
          })
        );
      }
    });
    getList(initialForm);
  }, []);
  const { handleChange, values, handleSubmit, touched, errors } = useFormik({
    initialValues: dynamicForm,
    validationSchema: Yup.object({
      rowCount: Yup.number()
        .integer("Positive value only")
        .positive("Positive value only")
        .required("Positive value only"),
      toDate: Yup.string().required("End Date is Required"),
      fromDate: Yup.string().required("Start Date is Required"),
      barcode: Yup.string().max(
        75,
        "Barcode should not be more than 75 characters"
      ),
    }),

    onSubmit: async (values: any, { setSubmitting }: FormikHelpers<any>) => {
      try {
        getList(values);
      } catch (err: any) { }
      setSubmitting(false);
    },
    enableReinitialize: true,
  });
  const clearAllFilter = () => {
    setDynamicForm(initialForm);
    getList(initialForm);
  };
  // useEffect(() => {
  //   handleSubmit();
  // }, [values]);
  return (
    <div className="api-log-content-wrapper">
      {logDDCalLoading || getLogListLoading ? <Loading /> : null}
      <div className="api-log-header">
        <h2>API Message Log</h2>
      </div>
      <div className="report-filter-wrapper">
        <Form onSubmit={handleSubmit}>
          <div className="report-filter-item-wrapper">
            <div className="filter-item-box">
              <Form.Label className="form-label"># of Records</Form.Label>
              <Form.Control
                type="number"
                min={0}
                className="form-control"
                placeholder="No. of Records"
                id="rowCount"
                onChange={(e: any) => {
                  handleChange("rowCount")(e.target.value);
                }}
                isInvalid={touched.rowCount && !!errors.rowCount}
                value={values.rowCount}
              />
              {touched.rowCount && errors.rowCount ? (
                <Form.Control.Feedback type="invalid">
                  {errors.rowCount}
                </Form.Control.Feedback>
              ) : null}
            </div>
            <div className="filter-item-box type-filter-item">
              <Form.Label className="form-label">Error Code</Form.Label>
              <Select
                isSearchable={true}
                classNamePrefix="react-select"
                options={errorCodeOptions}
                className="react-select-container"
                id="message"
                name="message"
                value={errorCodeOptions?.find(
                  (option: DropDownValues) => option.value === values.message
                )}
                onChange={(option: any) => {
                  handleChange("message")(option.value);
                }}
              />
            </div>
            <div className="filter-item-box">
              <Form.Label className="form-label">Barcode</Form.Label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Barcode"
                id="barcode"
                onChange={(e) => {
                  handleChange("barcode")(e.target.value ?? "");
                  handleSubmit();
                }}
                value={values.barcode}
              />
            </div>
            <div className="filter-item-box">
              <label className="form-label">Type</label>
              <Select
                isSearchable={true}
                classNamePrefix="react-select"
                options={typeOptions}
                className="react-select-container"
                id="type"
                name="type"
                value={typeOptions?.find(
                  (option: DropDownValues) => option.value === values.type
                )}
                onChange={(option: any) => {
                  handleChange("type")(option.value);
                }}
              />
            </div>
            <div className="filter-item-box">
              <Form.Label className="form-label">Start Date</Form.Label>
              <DatePicker
                locale="en-US"
                format="MM/dd/yyyy"
                openCalendarOnFocus={false}
                value={values.fromDate}
                showLeadingZeros={true}
                dayPlaceholder="dd"
                monthPlaceholder="mm"
                yearPlaceholder="yyyy"
                clearIcon={null}
                calendarIcon={<i className="bi bi-calendar"></i>}
                maxDate={values.toDate ? new Date(values.toDate) : new Date()}
                onChange={(date: any) => {
                  handleChange({
                    target: {
                      name: "fromDate",
                      value: moment(date)
                        .utc()
                        .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
                    },
                  });
                }}
                className={`${touched.fromDate && !!errors.fromDate
                  ? "is-invalid-border"
                  : ""
                  } form-control`}
              />
              {touched.fromDate && errors.fromDate && (
                <Form.Control.Feedback type="invalid">
                  {errors.fromDate}
                </Form.Control.Feedback>
              )}
            </div>
            <div className="filter-item-box">
              <Form.Label className="form-label">End Date</Form.Label>
              <DatePicker
                locale="en-US"
                format="MM/dd/yyyy"
                openCalendarOnFocus={false}
                value={values.toDate}
                showLeadingZeros={true}
                dayPlaceholder="dd"
                monthPlaceholder="mm"
                yearPlaceholder="yyyy"
                clearIcon={null}
                calendarIcon={<i className="bi bi-calendar"></i>}
                maxDate={new Date()}
                minDate={
                  values.fromDate ? new Date(values.fromDate) : new Date()
                }
                onChange={(date: any) => {
                  handleChange({
                    target: {
                      name: "toDate",
                      value: moment(date)
                        .utc()
                        .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
                    },
                  });
                }}
                className={`${touched.toDate && !!errors.toDate ? "is-invalid-border" : ""
                  } form-control`}
              />
              {touched.toDate && errors.toDate && (
                <Form.Control.Feedback type="invalid">
                  {errors.toDate}
                </Form.Control.Feedback>
              )}
            </div>
            <div className="filter-item-box clear-all-box">
              <Button type="submit" variant="primary">
                View
              </Button>
              <button
                type="button"
                className="clear-filter-btn"
                onClick={clearAllFilter}
              >
                Clear All
              </button>
            </div>
          </div>
        </Form>
      </div>
      <div className="filter-detail-wrapper">
        <div className="filter-item-detail-wrapper">
          <div className="filter-item-detail-table-wrapper">
            <Table bordered={false} hover={true}>
              <thead>
                <tr>
                  <th>Request Date</th>
                  <th>Barcode</th>
                  <th>Item Name</th>
                  <th>NDC code</th>
                  <th>Units</th>
                  <th>Locations</th>
                  <th>Query</th>
                  <th>User Id</th>
                  <th>HCP Id</th>
                  <th>Error Message</th>
                  <th>Comments</th>
                  <th>Record Type</th>
                </tr>
              </thead>
              <tbody>
                {logList?.map((item: ApiLog) => {
                  const queryStatus = parseBoolean(item?.query);

                  return (
                    <tr key={item.id}>
                      <td>
                        <span
                          className="clickable-text"
                          onClick={() => {
                            setSelectedRow(item);
                            toggleModal();
                          }}
                        >
                          {moment(item.eDate).format("MM/DD/YYYY hh:mm:ss A")}
                        </span>
                      </td>
                      <td>{item.barcode}</td>
                      <td>{item.rxName}</td>
                      <td>{item.ndcCode}</td>
                      <td>{item.units}</td>
                      <td>{item.location}</td>
                      <td>
                        <span className={`status-tag ${queryStatus ? "active" : "inactive"}`}>
                          {queryStatus ? "True" : "False"}
                        </span>
                      </td>
                      <td>{item.userId}</td>
                      <td>{item.hcpId}</td>
                      <td title={item.message}>{item.message}</td>
                      <td title={item.comment}>{item.comment}</td>
                      <td>{item.recordType}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
      {showModal && (
        <CustomModal
          id="param_detail_modal"
          title="API Details"
          content={
            <>
              <div className="modal--content--wrapper">
                <div className="param-content-box">
                  <div className="param-content-header">
                    <h4>Request</h4>
                    <OverlayTrigger
                      placement="top"
                      overlay={renderTooltip}
                      delay={{ show: 250, hide: 400 }}
                    >
                      <span
                        className="copy-icon k-cursor-pointer"
                        onClick={() => handleCopy(selectedRow?.reqString ?? "")}
                      >
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={duplicateicon}
                        />
                      </span>
                    </OverlayTrigger>
                  </div>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    value={selectedRow?.reqString}
                  />
                </div>
                <div className="param-content-box">
                  <div className="param-content-header">
                    <h4>Response</h4>
                    <OverlayTrigger
                      placement="top"
                      overlay={renderTooltip}
                      delay={{ show: 250, hide: 400 }}
                    >
                      <span
                        className="copy-icon k-cursor-pointer"
                        onClick={() => handleCopy(selectedRow?.resString ?? "")}
                      >
                        <ReactSVG
                          className="svg-box"
                          wrapper="span"
                          src={duplicateicon}
                        />
                      </span>
                    </OverlayTrigger>
                  </div>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    value={selectedRow?.resString}
                  />
                </div>
              </div>
            </>
          }
          onClose={toggleModal}
        />
      )}
    </div>
  );
};

export default ApiMsgLog;
